<script>
  import { page } from '$app/state';
  import { ChevronDown } from 'lucide-svelte';
  import { onMount } from 'svelte';

  let { id, label, paths = [], menuCommand = null, onOpenChange = null, children } = $props();
  let open = $state(false);
  let active = $derived(paths.includes(page.url.pathname));

  // 직접 진입·뒤로가기로 이동한 화면의 상위 그룹도 펼친다.
  $effect(() => {
    if (active) open = true;
  });

  $effect(() => {
    if (menuCommand) open = menuCommand.open;
  });

  // 부모의 '모두 열기/닫기' 라벨이 실제 열림 상태를 따르도록 마운트 시 등록하고, 이후 변화는 toggle 이벤트로 알린다
  // (핸들러가 bind:open 갱신보다 먼저 돌 수 있어 DOM 값을 읽는다).
  // 그룹이 사라지면 null로 해제한다.
  onMount(() => {
    onOpenChange?.(id, open);
    return () => onOpenChange?.(id, null);
  });
</script>

<!-- 그룹은 제목 클릭(Enter·Space 포함)으로만 열고 닫는다. -->
<details class="sidebar-group" class:active bind:open ontoggle={(e) => onOpenChange?.(id, e.currentTarget.open)}>
  <summary {id} class="sidebar-section-toggle">
    <span>{label}</span>
    <ChevronDown size={16} class="sidebar-chevron" />
  </summary>
  <div class="sidebar-group-content">
    {@render children()}
  </div>
</details>
